const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";
export const BACKEND_URL = API_BASE_URL.replace(/\/api$/, "");

export const API_URLS = {
  LOGIN: `${API_BASE_URL}/auth/login`,
  VERIFY_OTP: `${API_BASE_URL}/auth/verify-otp`,
  RESEND_OTP: `${API_BASE_URL}/auth/resend-otp`,
  REFRESH_TOKEN: `${API_BASE_URL}/auth/refresh-token`,
  ME: `${API_BASE_URL}/auth/me`,
  CHANGE_PASSWORD: `${API_BASE_URL}/auth/change-password`,
  SESSIONS: `${API_BASE_URL}/auth/sessions`,
  USERS: `${API_BASE_URL}/users`,
  ACCESS: `${API_BASE_URL}/access`,
  DASHBOARD: `${API_BASE_URL}/dashboard`,
  INCENTIVE: `${API_BASE_URL}/incentive`,
  CALENDAR: `${API_BASE_URL}/calendar`,
  COMPANIES: `${API_BASE_URL}/companies`,
  QUALIFICATIONS: `${API_BASE_URL}/qualifications`,
  SUB_QUALIFICATIONS: `${API_BASE_URL}/sub-qualifications`,
  EQUIPMENT: `${API_BASE_URL}/equipment`,
  CERTIFICATIONS: `${API_BASE_URL}/certifications`,
  VENDORS: `${API_BASE_URL}/vendors`,
  CUSTOMERS: `${API_BASE_URL}/customers`,
  DISCIPLINES: `${API_BASE_URL}/disciplines`,
  SUBDISCIPLINES: `${API_BASE_URL}/subdisciplines`,
  PRODUCTS: `${API_BASE_URL}/products`,
  SERVICES: `${API_BASE_URL}/services`,
  CERTIFICATES: `${API_BASE_URL}/certificates`,
  INSPECTORS: `${API_BASE_URL}/inspectors`,
  ENQUIRIES: `${API_BASE_URL}/enquiries`,
  WORKORDERS: `${API_BASE_URL}/workorders`,
  FINANCE_DASHBOARD:      `${API_BASE_URL}/finance/dashboard`,
  FINANCE_SALES_INVOICES: `${API_BASE_URL}/finance/sales-invoices`,
  FINANCE_NOTIFICATIONS:  `${API_BASE_URL}/finance/notifications`,
  FINANCE_CURRENCY_RATES: `${API_BASE_URL}/finance/currency-rates`,
  FINANCE_PAYABLES:       `${API_BASE_URL}/finance/payables`,
};


export const ROLE_LABELS = {
  global_superadmin: "Global Super Admin",
  company_admin: "Company Admin",
  admin: "Admin",
  hod: "HOD",
  project_manager: "Project Manager",
  coordinator: "Coordinator",
  it: "IT",
  finance: "Finance",
};

// Which roles each actor can create
// finance is peer-ranked with company_admin — only global_superadmin can create either.
export const CREATABLE_ROLES_BY_ACTOR = {
  global_superadmin: ["global_superadmin", "company_admin", "admin", "hod", "project_manager", "coordinator", "it", "finance"],
  company_admin: ["admin", "hod", "project_manager", "coordinator", "it"],
  admin: ["hod", "project_manager", "coordinator", "it"],
};